import React from 'react';
import { Tag } from 'antd';
import clsx from 'clsx';
import { useNavigate } from 'react-router-dom';
import styles from '../index.module.scss';
import DisplayHtmlContent from '../../../../Common/DisplayHtmlContent';
import { IconArrow } from '../../../../Common/Icon';
import { formatDate } from '../../../../../utils'; // adjust this path

interface TippingArticleCardProps {
  item: {
    id: string;
    name: string;
    description: string;
    file?: { location: string };
    tags: { id: string; name: string }[];
    createdAt: string;
  };
  onClick?: () => void;
  className?: string;
}

function TippingArticleCard({
  item,
  onClick,
  className,
}: TippingArticleCardProps) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) onClick();
    else navigate(`/tipping-articles/${item.id}`);
  };

  return (
    <div
      key={item.id}
      className={clsx(styles.card, className)}
      role="button"
      tabIndex={-1}
      onClick={handleClick}
    >
      {item.file && (
        <div>
          <img src={item.file.location} alt={item.name} className={styles.thumbnail} />
        </div>
      )}

      <div className={styles.info}>
        <h3 className={styles.infoName}>{item.name}</h3>
        <div style={{ marginTop: '20px' }} className={styles.infoContent}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
            }}
          >
            <DisplayHtmlContent
              html={item.description}
              className={clsx('article-span-item', 'description-display')}
            />
            {item.tags.length > 0 && (
              <div style={{ display: 'flex', gap: '2px' }}>
                {item.tags.map((tag) => (
                  <Tag key={tag.id}>{tag.name}</Tag>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      <div className={styles.infoFooter}>
        <div className={styles.read}>
          <IconArrow />
          <div>Read Article</div>
        </div>
        <span style={{ color: '#00000066' }}>{formatDate(item.createdAt)}</span>
      </div>
    </div>
  );
}

export default TippingArticleCard;
